/* eslint-disable-next-line */
type ErrorMessageProps = {
  errorMessage: string;
  shouldDisplayMessage: boolean;
};

export function ErrorMessage(props: ErrorMessageProps) {
  const { errorMessage, shouldDisplayMessage } = props;

  return (
    <small
      className={`font-MuseoSans500 !text-overline text-left text-red-900 ${
        shouldDisplayMessage ? 'block' : 'hidden'
      }`}
    >
      {errorMessage}
    </small>
  );
}

export default ErrorMessage;
